import { MemoType } from 'models/Memo';

// Every type the composer can create, in the order the type picker shows
// them. The picker fills its two columns top to bottom: the first five are
// the left column, the last five the right.
export const COMPOSER_TYPES = [
  MemoType.Text,
  MemoType.Quote,
  MemoType.Link,
  MemoType.TaskList,
  MemoType.Calendar,
  MemoType.Image,
  MemoType.Video,
  MemoType.Audio,
  MemoType.File,
  MemoType.Doc,
];

// The types that get their own button on the resting composer row. The rest
// are reached through the "more" button next to them.
export const QUICK_TYPES = [
  MemoType.Link,
  MemoType.TaskList,
  MemoType.Image,
  MemoType.Audio,
  MemoType.Calendar,
];
